var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryMenuIconV4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 9.18519C2.66669 6.23967 5.0545 3.85185 8.00002 3.85185C10.9455 3.85185 13.3334 6.23967 13.3334 9.18519C13.3334 10.6133 12.7713 11.9114 11.8575 12.8682C10.8871 13.8843 9.51711 14.5185 8.00002 14.5185C5.0545 14.5185 2.66669 12.1307 2.66669 9.18519ZM8.00002 5.03704C5.70906 5.03704 3.85187 6.89423 3.85187 9.18519C3.85187 11.4761 5.70906 13.3333 8.00002 13.3333C9.18011 13.3333 10.2443 12.8413 11.0004 12.0496C11.712 11.3045 12.1482 10.2964 12.1482 9.18519C12.1482 6.89423 10.291 5.03704 8.00002 5.03704Z",
    fill: "#45455A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0254 3.72912C12.2569 3.4977 12.6321 3.4977 12.8635 3.72912L14.0487 4.91431C14.2801 5.14573 14.2801 5.52094 14.0487 5.75236C13.8172 5.98378 13.442 5.98378 13.2106 5.75236L12.0254 4.56718C11.794 4.33575 11.794 3.96055 12.0254 3.72912Z",
    fill: "#45455A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 5.92593C8.3273 5.92593 8.59261 6.19124 8.59261 6.51852V9.48148C8.59261 9.80876 8.3273 10.0741 8.00002 10.0741C7.67274 10.0741 7.40742 9.80876 7.40742 9.48148V6.51852C7.40742 6.19124 7.67274 5.92593 8.00002 5.92593Z",
    fill: "#45455A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92595 2.66667C5.92595 2.33939 6.19126 2.07407 6.51854 2.07407H9.4815C9.80878 2.07407 10.0741 2.33939 10.0741 2.66667C10.0741 2.99395 9.80878 3.25926 9.4815 3.25926H6.51854C6.19126 3.25926 5.92595 2.99395 5.92595 2.66667Z",
    fill: "#45455A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryMenuIconV4);
export default __webpack_public_path__ + "static/media/history-menu-icon-v4.fecc49ee9b7da30cb281b246f5e058c3.svg";
export { ForwardRef as ReactComponent };